export default "__VITE_ASSET__BqKb29xh__"